<button class="btn {{ btnClass }}" [type]="type" [disabled]="loading || disabled" [ngClass]="{ loading: loading }"
	style="{{ style }}">
	<div class="btn-spinner float-left" *ngIf="loading"></div>
	<span *ngIf="!loading">
		<ng-content></ng-content>
	</span>
	<span *ngIf="loading">{{ loadingText }}</span>
</button>